import React from "react";

import styles from "./FooterLinks.module.scss";

type Page = {
    id: number;
    url: string | null;
    title: string;
};

export const FooterLinks = (props: {
    faqPage: Page;
    unsubscribePage: Page;
}) => (
    <div className={styles.footerLinks}>
        <a
            target="_blank"
            rel="noreferrer"
            href={props.faqPage.url ?? undefined}
            className={styles.footerLink}
        >
            Browse Faq
        </a>
        <a
            target="_blank"
            rel="noreferrer"
            href={props.unsubscribePage.url ?? undefined}
            className={styles.footerLink}
        >
            Unsubscribe
        </a>
    </div>
);
